export default __webpack_public_path__ + "static/media/SourceSans3-SemiBold.d40d7208.ttf";